export const parseAttributeFilterValue = (val: string): number =>
  parseInt(val.split('-').pop() ?? val);

export const isBooleanFilter = (value: string) =>
  value === 'true' || value === 'false';

export const parseQueryParamsFilterValues = (val: string): string =>
  isBooleanFilter(val) ? val : `${parseAttributeFilterValue(val)}`;
